
        import { makeFungusComponent } from '@/vue/decorators/angular-interop';
        export default function (Component) {
            const template = "\n<vrm-red-banner installation=\"installation\" />\n";
            const query = {"vue":"","type":"custom","index":"0","blockType":"angular-template","tag":"div"};
            makeFungusComponent(Component, template, query);
        }
    